import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, filter } from 'rxjs';

import { ProcessarRetornoJobService } from './processar-retorno-job.service';
import { NotificacoesService } from './notificacoes.service';

const PROCESSAR_RETORNO_ROUTE = '/arrecadacao/servicos/processar-retorno';

@Injectable({ providedIn: 'root' })
export class ProcessarRetornoJobToastService {
    private readonly jobService = inject(ProcessarRetornoJobService);
    private readonly notificacoesService = inject(NotificacoesService);

    constructor() {
        this.jobService.restaurar();

        this.jobService.snapshot$
            .pipe(
                filter((job) => Boolean(job?.jobId) && (job?.status === 'DONE' || job?.status === 'ERROR')),
                distinctUntilChanged((a, b) => a?.jobId === b?.jobId && a?.status === b?.status),
                takeUntilDestroyed()
            )
            .subscribe((job) => {
                if (job?.status === 'DONE') {
                    this.notificacoesService.notificar({
                        severity: 'success',
                        summary: 'Retorno processado',
                        detail: job.message ?? 'O arquivo retorno foi processado.',
                        link: `${PROCESSAR_RETORNO_ROUTE}/${encodeURIComponent(job.jobId)}`,
                        linkLabel: 'Ver processamento',
                        life: 10000
                    });
                    return;
                }

                if (job?.status === 'ERROR') {
                    this.notificacoesService.notificar({
                        severity: 'error',
                        summary: 'Erro no retorno',
                        detail: job.errorMessage ?? 'Falha ao processar o arquivo de retorno.',
                        link: `${PROCESSAR_RETORNO_ROUTE}/${encodeURIComponent(job.jobId)}`,
                        linkLabel: 'Ver processamento',
                        life: 10000
                    });
                }
            });
    }
}

export const initializeProcessarRetornoJobToasts = () => {
    inject(ProcessarRetornoJobToastService);
};
